import { render, staticRenderFns } from "./packageAdd.vue?vue&type=template&id=2377a30c&scoped=true"
import script from "./packageAdd.vue?vue&type=script&lang=js"
export * from "./packageAdd.vue?vue&type=script&lang=js"
import style0 from "./packageAdd.vue?vue&type=style&index=0&id=2377a30c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2377a30c",
  null
  
)

export default component.exports